export const PARAGRAPH_SPACING = '<p class="p1">&nbsp;</p>'

function tagAttrs(attributes?: Record<string, string>) {
  let attrs = ''
  if (attributes) {
    attrs =
      ' ' +
      Object.entries(attributes)
        .map(([key, val]) => `${key}="${val}"`)
        .join(' ')
  }
  return attrs
}

export function wrapTag(
  tag: string,
  content: string,
  attributes?: Record<string, string>,
) {
  return `<${tag}${tagAttrs(attributes)}>${content}</${tag}>`
}

export function wrapB(content: string) {
  return wrapTag('strong', content)
}
export function wrapP(content: string, attributes?: Record<string, string>) {
  if (!content) return ''
  return wrapTag('p', content, attributes)
}

export function wrapSpan(content: string, attributes?: Record<string, string>) {
  if (!content) return ''
  return wrapTag('span', content, attributes)
}

export function createAnchor({
  link,
  display,
  newTab,
}: {
  link: string
  display: string
  newTab?: boolean
}) {
  return wrapTag('a', display, {
    href: link,
    ...(newTab ? { target: '_blank', rel: 'noopener noreferrer' } : {}),
  })
}

export function createImgTag({
  src,
  attributes = {},
}: {
  src: string
  attributes?: Record<string, string>
}) {
  return `<img${tagAttrs({ ...attributes, src })}>`
}

export function createUnorderedList(listItems: string[]) {
  if (!listItems.length) return ''
  return wrapTag(
    'ul',
    listItems
      .map((item, index) => {
        return wrapTag('li', item)
      })
      .join(''),
  )
}

export function createTable(
  tableData: string[][],
  options?: {
    colWidths?: number[]
    tableStyle?: Record<string, string>
    cellStyle?: (row: number, cell: number) => Record<string, string>
  },
) {
  const addStyles = (element: HTMLElement, styles?: Record<string, string>) => {
    if (!styles) return
    Object.entries(styles).forEach(([attr, value]) => {
      element.setAttribute(attr, value)
    })
  }

  const table = document.createElement('table')
  addStyles(table, options?.tableStyle)
  tableData.forEach((cells) => {
    const row = table.insertRow()
    cells.forEach((content) => {
      const cell = row.insertCell()
      cell.innerHTML = content
      addStyles(cell, options?.cellStyle?.(row.rowIndex, cell.cellIndex))
      const colWidth = options?.colWidths?.[cell.cellIndex]
      if (colWidth) {
        cell.style.width = `${colWidth}%`
      }
    })
  })
  return table.outerHTML
}
